import { jsxs, jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { memo, useRef, useState } from "react";
import { mapSizeVariant } from "./constants.js";
import SvgClose from "./images/close.svg.js";
import { StyledTag, StyledIconContainer } from "./styles.js";
import "../Button/Button.js";
import "../InputControl/InputControl.js";
import "../InputControl/Input/InputBase.js";
import "../PhoneInputControl/PhoneInputControl.js";
import "../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../IconButton/IconButton.js";
import "../common/ControlBody.js";
import "../SelectControl/Select/context/SelectContext.js";
import "../Dialog/Dialog.js";
import "../IconButtonNew/IconButton.js";
import "../../icons/24/Action/Close.js";
import "../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../utils/dataTestId.js";
import "../SelectControl/Select/components/SelectInput/SelectInput.js";
import "../SelectControl/Select/MultiSelect/context/MultiSelectContext.js";
import "../../icons/24/System/Check.js";
import "../../icons/24/Arrow/ChevronDown.js";
import "../TextareaControl/TextareaControl.js";
import "../SearchControl/SearchControl.js";
import "../../icons/24/System/Search.js";
import "../FormattedPhone/FormattedPhoneNumber.js";
import { Tooltip } from "../Tooltip/Tooltip.js";
import "../Avatar/styles.js";
import "../CheckboxGroup/Checkbox/styles.js";
import "../CheckboxGroup/styles.js";
import "../RadioGroup/Radio/styles.js";
import "../RadioGroup/styles.js";
import "../RatingButton/styles.js";
import "../FloatingActionButton/styles.js";
import "../SortingButton/styles.js";
import "../SquareButton/styles.js";
import "../Toggle/styles.js";
import "../Dialog/StyledDialog.js";
import "../Chips/Chip/styles.js";
import "../ResultMarksNumber/styles.js";
import "../Progress/ProgressCircle/styles.js";
import "../Loaders/LoaderCircle/styles.js";
import "../Loaders/LoaderLine/styles.js";
import "../SegmentedControl/styles.js";
import "../ResultMarksText/styles.js";
import "../Link/styles.js";
import "../DatePicker/constants.js";
import "../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../external/classnames/index.js";
import "../Scrollbar/Scrollbar.js";
import "../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../MobileBottomSheet/MobileBottomSheet.js";
import "../List/ListItem/ListItem.js";
import "../Nowrap.js";
import "../List/ListItemTree/TreeListItem.js";
import "../List/ListItemTree/components/Label.js";
const Tag = memo(
  ({
    size = "xs",
    color = "blue",
    type = "square",
    onClose,
    label,
    disabled,
    sx,
    className,
    onClick,
    id,
    ...props
  }) => {
    const ref = useRef(null), [tooltipEnabled, setTooltipEnabled] = useState(!1), hasEllipsis = () => {
      const el = ref.current;
      if (!el) return;
      const originalOverflow = el == null ? void 0 : el.style.overflow;
      el.style.overflow = "hidden";
      const hasOverflow = el.scrollWidth > el.clientWidth;
      return el.style.overflow = originalOverflow, hasOverflow;
    }, checkEllipsis = () => {
      hasEllipsis() ? setTooltipEnabled(!0) : setTooltipEnabled(!1);
    }, tag = /* @__PURE__ */ jsxs(
      StyledTag,
      {
        id,
        onClick,
        interactive: !!onClick,
        size,
        color,
        type,
        disabled,
        onClose,
        className,
        sx,
        onMouseOver: checkEllipsis,
        onTouchStart: checkEllipsis,
        "data-test-id": props["data-test-id"],
        children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              ref,
              variant: mapSizeVariant[size],
              sx: { textOverflow: "ellipsis", overflow: "hidden", minWidth: 30 },
              children: label
            }
          ),
          onClose && /* @__PURE__ */ jsx(StyledIconContainer, { onClick: onClose, children: /* @__PURE__ */ jsx(SvgClose, {}) })
        ]
      }
    );
    return tooltipEnabled ? /* @__PURE__ */ jsx(
      Tooltip,
      {
        "data-test-id": inheritDataTestId(props, "tooltip"),
        title: label,
        placement: "top",
        onClose: () => setTooltipEnabled(!1),
        children: tag
      }
    ) : tag;
  }
);
Tag.displayName = "Tag";
export {
  Tag
};
//# sourceMappingURL=Tag.js.map
